export default {"src":"/_next/static/media/enviaflores.cbe2c7c2.svg","height":45,"width":225};